module.exports = __webpack_public_path__ + "img/p2-92.46f3f6e9.png";